var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrowGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.43,
    height: 13.595,
    viewBox: "0 0 18.43 13.595",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_41255",
    "data-name": "Path 41255",
    d: "M34.108,138.022h0l-5.729-5.7a1.1,1.1,0,0,0-1.547,1.554l3.846,3.828H17.1a1.1,1.1,0,1,0,0,2.193H30.678l-3.846,3.828a1.1,1.1,0,0,0,1.547,1.554l5.729-5.7h0A1.1,1.1,0,0,0,34.108,138.022Z",
    transform: "translate(-16 -132)",
    fill: "#72d54a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowGreen);
export default __webpack_public_path__ + "static/media/right-arrow-green.71db9ec2e14bb25c559d87a636c1faed.svg";
export { ForwardRef as ReactComponent };